import React from 'react'
import TopSlider from './topSlider'
import Explore from './explore'
import Feeds from './feeds'
import '../../../css/public/home.css';
import DocumentMeta from 'react-document-meta';

const Index = ({HomeSwitch,SetHomeSwitch}) => {
  const meta = {
    title: 'KAAY, The Easy Way | Pakistan’s 1st ever social commerce platform',
    description: 'Kaay is pakistan’s 1st ever social commerce platform with the vision to empower SMEs, Local vendors & Artists of Pakistan. It connects Pakistani sellers with buyers from all over the world providing them a unique & personalized shopping experience with full transparency.',
    canonical: window.location.href
    /*canonical: 'http://example.com/path/to/page',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'react,meta,document,html,tags'
        }
    }*/
  }
  return (
    <>
    <DocumentMeta {...meta} />
        <TopSlider />
        <div className='public_home_pagesswitch_container'>
            <div className={HomeSwitch === 0?'public_home_exploretab_container active':'public_home_exploretab_container'} onClick={
                ()=>{SetHomeSwitch(0);}
            }>
                <h5>Explore</h5>
            </div>
            <div className={HomeSwitch === 1?'public_home_feedtab_container active':'public_home_feedtab_container'} onClick={
                ()=>{SetHomeSwitch(1);}
            }>
                <h5>Feed</h5>
            </div>
        </div>
        <div className='public_home_pages_container'>
            {HomeSwitch===0 &&
              <Explore/>
            }
            {HomeSwitch===1 &&
              <Feeds/>
            }
        </div>
    </>
  )
}

export default Index
